import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import {
  FormTemplate,
  FormSelectAlt,
  PerfectFileUpload,
  FileUpload,
  FileUploadAlt,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { CreateCostClass } from "../../../../../utils/redux/Finance/CostCenterSlice/CostCenterSlice";
import axios from "axios";
import {
  GetGlobalData,
  PreviewBankStatementThunk,
  UploadBankStatementThunk,
} from "../../../../../utils/redux/Finance/AnalyseCompanyFund/AnalyseCompanyFundSlice";
import { TableActions } from "../../../Components/Misc/ActionsModVersion";
import Table from "../../../Components/Table/Table";
import { getStatusText } from "../CostCenter/Class";
import { useGetAllAccountsQuery } from "../../../../api";

function UploadBankStatement() {
  const { data: banks } = useGetAllAccountsQuery({
    Search: "bank",
    PageSize: 10000,
    PageNumber: 1,
  });
  console.log("banks", banks);
  
  const navigate = useNavigate();
  const formMethods = useForm({
    mode: "all",
  });
  
  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods;

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [xData, setXData] = useState({});

  const { GlobalData } = useSelector((state) => state.companyFund);

  useEffect(() => {
    dispatch(GetGlobalData()); // Assuming GetGlobalData is defined in your Redux actions
  }, [dispatch]);

  useEffect(() => {
    if (selectedBank && file) {
      previewBankStatement();
    }
  }, [selectedBank, file]);

  function previewBankStatement() {
    if (!selectedBank) {
      return; // Handle case where selectedBank is not defined
    }

    setLoading(true);
    let formData = {};
    formData.File = file;
    formData.BankName = selectedBank.accountName;
    formData.AccountNumber = selectedBank.accountNumber;
    
    dispatch(PreviewBankStatementThunk(formData)).then((response) => {
      let fmtData = response.payload;
      setXData(fmtData);
      setLoading(false);
      // reset()
    }).catch(error => {
      setLoading(false); // Handle error case
      console.error('Error previewing bank statement:', error);
    });
  }

  function uploadBankStatement() {
    if (!xData || !xData.fTransaction) {
      return; // Handle case where xData or xData.fTransaction is not defined
    }

    const fmtData = {
      companyFundEntry: xData.fTransaction,
      accountNumber: xData.accountNumber,
    };

    dispatch(UploadBankStatementThunk(fmtData)).then((response) => {
      reset();
      navigate(-1);
    }).catch(error => {
      console.error('Error uploading bank statement:', error);
    });
  }

  let currentHeaders = [
    {
      title: "Value Date",
      key: "valueDate",
    },
    {
      title: "Transfer Date",
      key: "tranDate",
    },
    {
      title: "Amount",
      key: "amount",
    },
    {
      title: "Position",
      key: "accountPosition",
    },
    {
      title: "Approval Status",
      key: "approvalStatus",
    },
    {
      title: "Comment",
      key: "comment",
    },
    {
      title: "Reference Number",
      key: "transRef",
    },
  ];

  return (
    <RouteLayout title={"Finance"}>
      <PageLayout title={"Upload Bank Statement"} hasBack={true}>
        <FormProvider {...formMethods}>
          <FormTemplate
            className={DashboardStyle.view_app_components}
            handleSubmit={handleSubmit(
              xData?.fTransaction?.length
                ? uploadBankStatement
                : previewBankStatement
            )}
          >
            <section className={DashboardStyle.form_section}>
              <h4
                className={`text-[#29382A] mt-5 text-[14px] font-[500] ${
                  xData?.fTransaction?.length && "hidden"
                }`}
              >
                Enter the required details
              </h4>
              <div className={DashboardStyle.inputs_group}>
                <div>
                  <FormSelectAlt
                    title={"Bank"}
                    camelCase={"BankName"}
                    placeholder={"Select Bank"}
                    isOptional={false}
                    array={banks?.result?.map((b) => (
                      <option key={b.accountNumber} value={b.accountNumber}>{b.accountName}</option>
                    ))}
                    moreRegister={{
                      onChange: (e) => {
                        let { value } = e.target;
                        let item = banks?.result?.find(
                          (b) => b.accountNumber === value
                        );
                        setSelectedBank(item);
                      },
                    }}
                  />
                </div>
                <div className="">
                  <FileUploadAlt
                    file={file}
                    camelCase={"File"}
                    setFile={setFile}
                    fileTypes={["XLSX", "CSV", "XLTX", "XLS"]}
                    title={"Attachment"}
                  />
                </div>
                {xData?.fTransaction?.length ? (
                  <div
                    className={`${DashboardStyle.dashboard_table_holder} max-w-[90vw] max-h-[50vh] overflow-auto`}
                  >
                    <Table>
                      <thead>
                        <tr>
                          {currentHeaders.map((header, i) => (
                            <th
                              className={`!text-[#29382A] ${
                                header.title === "Actions" &&
                                "flex justify-end !pr-6"
                              }`}
                              key={i}
                            >
                              {header.title}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <RequestTable
                          isLoading={false}
                          data={xData?.fTransaction}
                          keys={currentHeaders.map((header) => header.key)}
                          selectable={false}
                          rowOptions={null}
                        />
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <div style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    marginTop: "1rem",
                  }}>
                    {/* <a download className="underline" href={"/cashbook.xlsx"}>
                      Download Template
                    </a> */}
                    <a download className="underline" href={"/first bank.pdf"}>
                      Download Template (First Bank)
                    </a>
                    <a download className="underline" href={"/GTB SAMPLE.xltx"}>
                      Download Template (GTB)
                    </a>
                    <a download className="underline" href={"/Transaction History - NLPC PENSION FUND ADMINISTRATORS LI_0001622766.xls.xlsx"}>
                      Download Template (NLPC)
                    </a>
                  </div>
                )}
              </div>
            </section>

            <div className={DashboardStyle.button_cage}>
              <SupportButtons
                onClick={() => {
                  reset();
                  navigate(-1);
                }}
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
              >
                Cancel
              </SupportButtons>
              <ActionButtons
                width={"auto"}
                className={`${DashboardStyle?.button_cage_weight} ${
                  !xData?.fTransaction?.length && "!bg-cyan-700"
                }`}
              >
                {xData?.fTransaction?.length
                  ? "Confirm Upload"
                  : loading
                  ? "Loading Preview..."
                  : "Preview"}
              </ActionButtons>
            </div>
          </FormTemplate>
        </FormProvider>
      </PageLayout>
    </RouteLayout>
  );
}

export default UploadBankStatement;


function RequestTable({
  data,
  keys,
  selectable,
  HandleSelectedItems,
  selectedItems,
  rowOptions,
}) {
  return (
    <>
      {data?.map((item) => (
        <tr key={item.id}>
          {selectable && (
            <td>
              <input
                type="checkbox"
                checked={selectedItems.includes(item.id)}
                onChange={(e) => HandleSelectedItems(item.id, e.target.checked)}
                style={{ height: "20px", width: "20px" }}
              />
            </td>
          )}
          {keys
            .filter((key) => key)
            .map((key, i) => {
              return key === "approvalStatus" ? (
                <td key={i}>{getStatusText(item[key])}</td>
              ) : key === "accountPosition" ? (
                <td key={i}>
                  {item[key] === 0
                    ? "debit"
                    : item[key] === 1
                    ? "credit"
                    : null}
                </td>
              ) : (
                <td key={i}>{item[key]}</td>
              );
            })}

          <td>
            <div className={`flex justify-end bg-transparent`}>
              <TableActions rowData={item} children={rowOptions}>
                {rowOptions}
              </TableActions>
            </div>
          </td>
        </tr>
      ))}
    </>
  );
}
